import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get supplier
export const getSupplier = createAsyncThunk("supplier/getSupplier", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getSupplier({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all supplier
export const getAllSupplier = createAsyncThunk("supplier/getAllSupplier", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllSupplier();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("supplier/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("supplier/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk("supplier/getParticularPage", async (params, { rejectWithValue }) => {
  const { number, rowsPerPage, search } = params;
  try {
    const { data } = await API.getPageSupplier({ number, rowsPerPage: rowsPerPage, search });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getSupplierById = createAsyncThunk("supplier/getSupplierById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getSupplierById(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create supplier
export const createSupplier = createAsyncThunk("supplier/createSupplier", async (createData, { rejectWithValue }) => {
  const { otherDetails, contacts, docAttachments } = createData;
  try {
    const body = new FormData();
    // Append otherDetails to FormData
    Object.entries(otherDetails).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        body.append(`otherDetails[${key}]`, value);
      }
    });
    Object.entries(createData).forEach(([key, value]) => {
      if (key !== "contacts" && key !== "docAttachments" && key !== "otherDetails") {
        body.append(key, value);
      }
    });
    contacts?.length > 0 &&
      contacts.forEach((detail, i) => {
        body.append(`contacts[${i}][name]`, detail.name);
        body.append(`contacts[${i}][designation]`, detail.designation);
        body.append(`contacts[${i}][address]`, detail.address);
        body.append(`contacts[${i}][email]`, detail.email);
        body.append(`contacts[${i}][citizenshipNumber]`, detail.citizenshipNumber);
        body.append(`contacts[${i}][mobile1]`, detail.mobile1);
        body.append(`contacts[${i}][mobileNumber2]`, detail.mobileNumber2);
        body.append(`contacts[${i}][tel1]`, detail.tel1);
        body.append(`contacts[${i}][tel2]`, detail.tel2);
      });

    docAttachments?.length > 0 &&
      docAttachments.forEach((detail, i) => {
        body.append(`docAttachments[${i}][documentType]`, detail.documentType);
        body.append(`docAttachments[${i}][attachDocument]`, detail.attachDocument);
      });

    const { data } = await API.createSupplier(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateSupplier = createAsyncThunk("supplier/updateSupplier", async (updateData, { rejectWithValue }) => {
  const { id, values } = updateData;
  const { otherDetails, contacts, docAttachments } = values;
  try {
    const body = new FormData();
    // Append otherDetails to FormData
    Object.entries(otherDetails).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        body.append(`otherDetails[${key}]`, value);
      }
    });
    Object.entries(values).forEach(([key, value]) => {
      if (key !== "contacts" && key !== "docAttachments" && key !== "otherDetails") {
        body.append(key, value);
      }
    });
    contacts?.length > 0 &&
      contacts.forEach((detail, i) => {
        if (detail.id) {
          body.append(`contacts[${i}][id]`, detail.id);
        }
        body.append(`contacts[${i}][name]`, detail.name);
        body.append(`contacts[${i}][designation]`, detail.designation);
        body.append(`contacts[${i}][address]`, detail.address);
        body.append(`contacts[${i}][email]`, detail.email);
        body.append(`contacts[${i}][citizenshipNumber]`, detail.citizenshipNumber);
        body.append(`contacts[${i}][mobile1]`, detail.mobile1);
        body.append(`contacts[${i}][mobileNumber2]`, detail.mobileNumber2);
        body.append(`contacts[${i}][tel1]`, detail.tel1);
        body.append(`contacts[${i}][tel2]`, detail.tel2);
      });

    docAttachments?.length > 0 &&
      docAttachments.forEach((detail, i) => {
        if (detail.id) {
          body.append(`docAttachments[${i}][id]`, detail.id);
        }
        body.append(`docAttachments[${i}][documentType]`, detail.documentType);
        body.append(`docAttachments[${i}][attachDocument]`, detail.attachDocument);
      });

    const { data } = await API.updateSupplier(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("supplier/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
